import React, {Component} from 'react';

import _ from "lodash";
import swal from 'sweetalert2';
import axios from "axios/index";

import urls from "../../../../utils/urls";
import {tokenHeader} from "../../../../utils/headers";
import translator from "../../../../utils/translations";
import {ajaxHandler} from "../../../../utils/errors";
import helpers from "../../../../utils/helpers";

export default class ProductForm extends Component {

    constructor(props) {
        super(props);

        let activeState = {
            id: null,
            name: '',
            code: '',
            trip_type: helpers.trip_type.INTERNAL
        };

        if (this.props.item) {
            let product = this.props.item;
            activeState = {
                id: product.id,
                name: product.name,
                code: product.code,
                density_tolerance: product.density_tolerance ? product.density_tolerance : '',
                alcoholic_grade_tolerance: product.alcoholic_grade_tolerance ? product.alcoholic_grade_tolerance : '',
                volume_tolerance: product.volume_tolerance ? product.volume_tolerance : '',
                weight_tolerance: product.weight_tolerance ? product.weight_tolerance : '',
            };
        }

        this.state = {
            ...activeState,
            ajaxInProgress: false
        };
    }

    _handleInput = (prop, value) => {
        this.setState({[prop]: value});
    };

    _submitForm = () => {

        this.setState({ajaxInProgress: true});

        let excludedKeys = ['ajaxInProgress', 'id'];

        let data = _.omit(this.state, excludedKeys);
        Object.keys(data).forEach(key => {if (data[key] === ''){data[key] = null;}});

        if(this.state.id){
            const UPDATE_PRODUCT = `${urls.API_ROOT}/api/v1/product/id/${this.state.id}/`;
            axios.put(`${UPDATE_PRODUCT}`, data, tokenHeader())
                .then(this._onSubmitSuccess)
                .catch(this._onSubmitError);
        }else{
            const NEW_PRODUCT = `${urls.API_ROOT}/api/v1/product/`;
            axios.post(`${NEW_PRODUCT}`, data, tokenHeader())
                .then(this._onSubmitSuccess)
                .catch(this._onSubmitError);
        }
    };

    _onSubmitSuccess = () => {
        this.setState({ajaxInProgress: false});

        swal({
            title: `Producto ${this.state.id ? 'actualizado' : 'creado'}`,
            html: 'La información ingresada ha sigo guardada correctamente',
            type: 'success',
            showConfirmButton: false,
            timer: 2000
        });

        this.props.closeAction();
        this.props.refreshAction();
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido guardar la información del producto',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };

    render() {

        let isFE = false;
        if(this.props.item){
            isFE = this.props.item.trip_type === helpers.trip_type.FE;
        }

        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>{this.state.id ? 'Edición de Producto' : 'Alta Producto'}</h3>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        {isFE &&
                        <p className={'field-p'}>{this.props.item.name}</p>
                        }
                        {!isFE &&
                        <input placeholder={"Ingrese un valor"} value={this.state.name} type={"text"}
                               onChange={(ev) => this._handleInput('name', ev.target.value)}
                        />
                        }
                        <label className="active">Nombre</label>
                    </div>
                    <div className={"col s12 input-field"}>
                        {isFE &&
                        <p className={'field-p'}>{this.props.item.code}</p>
                        }
                        {!isFE &&
                        <input placeholder={"Ingrese un valor"} value={this.state.code} type={"text"}
                               onChange={(ev) => this._handleInput('code', ev.target.value)}
                        />
                        }
                        <label className="active">Código</label>
                    </div>
                </div>
                {isFE &&
                <div className={'row'}>
                    <div className={"col s6 input-field"}>
                        <input placeholder={"Ingrese un valor"} value={this.state.volume_tolerance} type={"text"}
                               onChange={(ev) => this._handleInput('volume_tolerance', ev.target.value)}
                        />
                        <label className="active">Tolerancia de volumen</label>
                    </div>
                    <div className={"col s6 input-field"}>
                        <input placeholder={"Ingrese un valor"} value={this.state.weight_tolerance} type={"text"}
                               onChange={(ev) => this._handleInput('weight_tolerance', ev.target.value)}
                        />
                        <label className="active">Tolerancia de peso</label>
                    </div>
                    <div className={"col s6 input-field"}>
                        <input placeholder={"Ingrese un valor"} value={this.state.density_tolerance} type={"text"}
                               onChange={(ev) => this._handleInput('density_tolerance', ev.target.value)}
                        />
                        <label className="active">Tolerancia de densidad</label>
                    </div>
                    {this.props.item && this.props.item.check_alcohol &&
                    <div className={"col s6 input-field"}>
                        <input placeholder={"Ingrese un valor"} value={this.state.alcoholic_grade_tolerance}
                               type={"text"}
                               onChange={(ev) => this._handleInput('alcoholic_grade_tolerance', ev.target.value)}
                        />
                        <label className="active">Tolerancia alcoholica</label>
                    </div>
                    }
                </div>
                }
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={`btn btn-shell-empty z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={`btn btn-shell z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this._submitForm}
                        >Guardar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/ProductForm.js